(function () {
  var el = document.querySelector('.product-details.sticky-content--desktop');
  if (!el) return;

  function update() {
    var height = el.scrollHeight;
    var vh = window.innerHeight;
    var headerOffset =
      parseFloat(getComputedStyle(el).getPropertyValue('--sticky-header-offset')) || 0;

    if (height + headerOffset > vh) {
      el.style.top = vh - height + 'px';
    } else {
      el.style.top = headerOffset + 'px';
    }
  }

  update();
  window.addEventListener('resize', update);
  new ResizeObserver(update).observe(el);
})();
